var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ../~/_lodash@4.17.15@lodash/_getPrototype.js
// module id = 444
// module chunks = 1